export const pickUniqueSipplierCodes = (supplierCodes: string[]): string[] =>
  Array.from(new Set(supplierCodes))

export const pluck = <T, K extends keyof T>(items: T[], idKey: K): T[K][] =>
  items.map((item) => item[idKey])

export const pluckIds = <T extends { id: string }>(items: T[]): string[] =>
  pluck<T, 'id'>(items, 'id')
